export enum FileUploadState {
  IDLE = 'IDLE',
  SUCCESS = 'SUCCESS',
  TIMEOUT = 'TIMEOUT',
  UPLOADING = 'UPLOADING',
  FAILED = 'FAILED',
  GENERATING = 'GENERATING',
}

export enum FileProcessingState {
  SUCCESS = 'SUCCESS',
  PROCESSING = 'PROCESSING',
  ERROR = 'ERROR',
}

